import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Footer() {
  return (
    <footer className="w-full bg-white border-t border-slate-200 font-sans">

      {/* COMPANY NAME - ADEYA */}
      <div className="w-full py-10 sm:py-12">
        <h1 className="w-full text-6xl sm:text-8xl md:text-9xl lg:text-[9vw] font-extrabold text-center leading-tight sm:leading-none text-sky-500/100 tracking-wider">
          A D E Y A
        </h1>
        <p className="text-center text-slate-500 text-sm mt-3 tracking-wide">
          Adeya IMS — Complete Inventory Management System
        </p>
      </div>

      {/* LINKS GRID */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 py-8 border-t border-slate-200">

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-3 text-slate-800 text-sm sm:text-base">Company</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li><Link to="/about" className="text-slate-700 hover:text-sky-500 transition">About</Link></li>
              <li><Link to="/careers" className="text-slate-700 hover:text-sky-500 transition">Careers</Link></li>
              <li><Link to="/contact" className="text-slate-700 hover:text-sky-500 transition">Contact</Link></li>
            </ul>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold mb-3 text-slate-800 text-sm sm:text-base">Product</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li><Link to="/features" className="text-slate-700 hover:text-sky-500 transition">Features</Link></li>
              <li><Link to="/pricing" className="text-slate-700 hover:text-sky-500 transition">Pricing</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3 text-slate-800 text-sm sm:text-base">Legal</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li><Link to="/privacy" className="text-slate-700 hover:text-sky-500 transition">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-slate-700 hover:text-sky-500 transition">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-semibold mb-3 text-slate-800 text-sm sm:text-base">Connect</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <a href="mailto:support@adeyaai.com" className="text-slate-700 hover:text-sky-500 transition break-all">
                  support@adeyaai.com
                </a>
              </li>
              <li>
                <a href="tel:+919822134536" className="text-slate-700 hover:text-sky-500 transition">
                  +91 98221 34536
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="text-center py-6 text-xs sm:text-sm text-slate-800 border-t border-slate-200 flex flex-col sm:flex-row justify-center items-center gap-2">
        <img src={logo} className="h-5 w-auto opacity-100" alt="Adeya" />
        <span>© {new Date().getFullYear()} ADEYA. All rights reserved.</span>
      </div>
    </footer>
  );
}